import { Component, OnInit } from '@angular/core';
import { FinanceService } from '../services/finance.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';

@Component({
  selector: '',
  template: '',
})
export class PaymentStatementDetailsSearchHandler extends BaseSearchComponent<FinanceService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;
  searchCriteriaData: any;
  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    // this.addLink = '/payment-statement-details';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchPaymentStatementDetails';

    //this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = false;

    let statementAndDetailLink = this.route.snapshot.paramMap.get('id');
    this.searchCriteriaData = { 'PaymentStatementDetailsDO.statementAndDetailLink': statementAndDetailLink };
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Payment Statement',
        link: '/search-payment-statement',
      },
      {
        id: 'Details',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Download',
        link: '/search-payment-statement/:id',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Payment Statement Details';
    header.title = this.settingService.getLabelValue('paymentStatementDetails');
    return header;
  }

  Download_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    //this.router.navigate([link]);
    this.getDocument(optionDetails.ref_id);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }

  getDocument(guid) {
    this.service.getDocument(guid).subscribe((successResponse) => {
      let respData = JSON.parse(JSON.stringify(successResponse));

      this.service.responseIO = respData;
      this.downloadOrOpenContent(
        respData.data.DOCUMENTS.documentContent,
        respData.data.DOCUMENTS.fileType,
        respData.data.DOCUMENTS.documentName
      );

      //this.offlineService.openPdf(respData.data.DOCUMENTS.documentContent);
    });
  }
}
